import React, { useState, useEffect, useImperativeHandle } from "react";
import { Table, Divider, message,Popconfirm } from "antd";
import { useHistory } from "react-router-dom";
import { getRule, deleteRule } from "@/api/operation";
import Search from "./Search";

const RuleTable = React.forwardRef((props, ref) => {
  const { onEdit = () => {}, onAdd = () => {} } = props;

  const history = useHistory();

  const [otherParams, setOtherParams] = useState({});

  const [dataSource, setDataSource] = useState([]);

  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const handleDelete = (record) => {
    deleteRule({ pointChargeRuleId: record.pointChargeRuleId }).then((res) => {
      if (res.success) {
        message.success("删除计费规则成功！");
        fetchList();
      }
    });
  };

  const fetchList = () => {
    getRule({
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      ...otherParams,
    }).then((res) => {
      if (res.success) {
        setDataSource(res.data.list);
        setPage({ ...page, total: res.data.total });
      }
    });
  };
  useEffect(() => {
    fetchList();
  }, [page.pageSize, page.pageNum, otherParams]);

  const onTableChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum, pageSize });
  };

  const onShowSizeChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum: 1, pageSize });
  };

  const handleSearch = (values) => {
    setOtherParams({ ...values });
    setPage({ ...page, pageNum: 1 });
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleRedirect = (current, type) => {
    if (type === "detail") {
      history.push(`/page/business/split/${current.companyId}`);
    } else {
      history.push(`/page/business/split/record/${current.companyId}`);
    }
  };

  const columns = [
    {
      title: "运营商名称",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "投放点位",
      dataIndex: "pointName",
      key: "pointName",
    },
    {
      title: "投放周期",
      dataIndex: "cycle",
      key: "cycle",
      render:(text)=>`${text} 天`
    },
    {
      title: "点位费用/元",
      dataIndex: "pointPrice",
      key: "pointPrice",
      render:(text)=>`${text} 元`
    },
    {
      title: "屏保费用/元",
      dataIndex: "advertisementPrice",
      key: "advertisementPrice",
      render:(text)=>`${text} 元`
    },
    {
      title: "操作",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div>
            <a onClick={() => onEdit(record)}>编辑</a>
            <Divider type="vertical" />
            <Popconfirm
              title="确认删除计费规则?"
              onConfirm={() => handleDelete(record)}
            >
              <a href="#">删除</a>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  useImperativeHandle(
    ref,
    () => ({
      fetchList,
    }),
    []
  );

  return (
    <div className="rule-table bg-white">

      <Search onAdd={onAdd} onSearch={handleSearch} />

      <div className="mt-24 pl-24 pr-24">

      <Table
        rowSelection={null}
        dataSource={dataSource}
        rowKey="pointChargeRuleId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />
      </div>
    </div>
  );
});

export default RuleTable;
